import Cookie from 'js-cookie';

const name = 'queryData';

//设置公告明细查询条件
export function setDetailQueryData(queryData){
    Cookie.set(name, JSON.stringify(queryData));
}

//获取公告明细查询条件
export function getDetailQueryData(){
    return JSON.parse(Cookie.get(name));
}
